<template>
  <div class="table-tab">
    <div class="admin-buy__block-gui-btn a-flex-start u-margin-b-24">
      <button class="gui-btn gui-btn--red" type="button" @click="onDownloadSpecClick">
        {{$t('buttons.download-specification')}}
      </button>
      <v-popover class="d-inline-block u-margin-right-20" placement="right">
        <img src="@/assets/img/static/info.svg">

        <template slot="popover">
            <span class="a-formatted-text text-left font-weight-normal">
  Шаблон предложения по присутствию в спецификации номенклатур, сопутствующих и доп. номенклатур, а так же партиям формируется на ЭТП и выгружается в шаблон предложения.
  Для загрузки предложения на ЭТП необходимо сформировать шаблон  предложения на ЭТП, выгрузить его, заполнить в соответствующих полях сведения в соответствии с форматом ячейки и ограничениям.
  Заполненный шаблон предложения сохраните на рабочем месте, а затем загрузите в соответствующую процедуру.
  ВНИМАНИЕ! любое не соответствие в шаблоне предложения на ЭТП и загружаемом файле будут игнорироваться.
            </span>
        </template>
      </v-popover>
      <file-picker accept="xlsx"
                   :label="'buttons.upload-specification'"
                   :signing="false"
                   @prepared="onFileSelected"
                   v-if="editable">
      </file-picker>
    </div>

    <specification-items-filter :parts="bid.parts"
                                :specs="bid.specs"
                                :validations="$v.bidParts"
                                v-model="filteredSpecs"> </specification-items-filter>

    <section v-maximizable>
      <div class="table-tab__container" style="overflow-x: auto">
      <table class="table-tab__block table " style="min-width: 1500px">
        <thead class="table-tab__thead">
          <tr class="">
            <th colspan="2" class="table-tab__border-bottom table-tab__width-90 table-tab__th--row">№</th>
            <th class="table-tab__border-bottom" style="width: 25%;">{{$t('form.lot.specs.nomenclature')}}</th>
            <th class="table-tab__border-bottom" style="width: 18%;">{{$t('form.lot.specs.quantity')}}</th>
            <th class="table-tab__border-bottom">{{$t('form.lot.specs.unit')}}</th>
            <th class="table-tab__border-bottom" style="width: 20%;">{{$t('form.lot.specs.price-per-unit')}}</th>
            <th class="table-tab__border-bottom">{{$t('form.lot.specs.total-price')}}</th>
            <th class="table-tab__border-bottom">{{$t('form.lot.specs.bid-currency')}}</th>
            <th class="table-tab__border-bottom">{{$t('form.lot.specs.contract-currency')}}</th>
            <th class="table-tab__border-bottom">Валютная оговорка</th>
            <th class="table-tab__border-bottom a-width-300">Консорциум</th>
            <th class="table-tab__border-bottom" v-if="canEditExtraCost">
              Добавить доп. расход
            </th>
            <th class="table-tab__border-bottom" v-else>
              Добавить сопутствующую номенклатуру
            </th>
            <th class="table-tab__border-bottom table-tab__width-180"></th>
          </tr>
        </thead>
        <tbody class="table-tab__tbody">
        <template v-for="(item, i) in specs">
          <!-- extra expense  -->
          <template v-if="item.isExtra">
            <tr>
              <!-- Открытие таба table-tab__btn-open-->
              <th class="table-tab__border-top"
                  :class="{'table-tab__background-black': item.isExtra}">
              </th>

              <th class="table-tab__border-top table-tab__th table-tab__th--row ">
                <!--              <img src="@/assets/img/static/arrow-up.png" alt="">-->
                {{item.serial}}
              </th>

              <!--  nomenclature  -->
              <td class="table-tab__border-top">
                <dropdown-new class="select-w-260"
                              :options="getExtraCosts(item)"
                              v-model="item.extraCost"
                              v-if="canEditExtraCost && item.editable"
                              @change="onExtraCostChange(item)">
                </dropdown-new>
                <template v-else>
                  {{getAdditionalCostName(item.extraCost)}}
                </template>
              </td>

              <td class="table-tab__border-top">
                <template v-if="item.percent">
                  <input-percent :value="item.count"
                                 @change="onFieldChange(item, 'count', $event)"
                                 v-if="canEditExtraCost && item.editable"></input-percent>
                  <label v-else>{{item.count | percent}}</label>
                </template>
                <template v-else>
                  <label>{{item.count}}</label>
                </template>
              </td>

              <template>
                <td class="table-tab__border-top" >
                  <template>
                    {{item.percent ? '% процент' : 'шт'}}
                  </template>
                </td>

                <td class="table-tab__border-top text-nowrap" v-if="item.percent">
                  {{item.price | price}}
                </td>
                <td class="table-tab__border-top" v-else>
                  <template v-if="canEditExtraCost && item.editable">
                    <div :class="{ 'a-input-group--error': $v.specs.$each[i].price.$dirty && !$v.specs.$each[i].price.validPrice }">
                      <input-cost class="a-input table-tab__input-max-width-85"
                                  :value="item.price"
                                  @change="onFieldChange(item, 'price', $event)"></input-cost>
                    </div>
                  </template>
                  <template v-else>
                    {{item.price | price}}
                  </template>
                </td>

                <td class="table-tab__border-top text-nowrap">
                  {{(item.price * (item.percent ? item.count / 10000 : item.count)) | price}}
                </td>

                <td class="table-tab__border-top">
                  <dropdown-new :options="getExtraCostBidCurrencies(item, 'currency')"
                                v-model="item.currency"
                                @change="onDependentFieldChange(item, 'currency', $event)"
                                v-if="!item.percent && item.editable"></dropdown-new>
                  <p v-else>{{$t(item.currency.label)}}</p>
                </td>

                <td class="table-tab__border-top">
                  <dropdown-new :options="getExtraCostPaymentCurrencies(item, 'currencyContract')"
                                v-if="item.editable"
                                @change="onDependentFieldChange(item, 'currencyContract', $event)"
                                v-model="item.currencyContract"></dropdown-new>
                  <p v-else>{{$t(item.currencyContract.label)}}</p>
                </td>

                <td class="table-tab__border-top">
                  <div class="a-checkbox">
                    <label class="a-checkbox__label" :class="{'a-checkbox__label--disable': !editable || getCurrencyClauseApplicability(item).length !== 2}" >
                      <input class="a-checkbox__input"
                             type="checkbox"
                             v-model="item.currencyClause"
                             @change="onDependentFieldChange(item, 'currencyClause', $event)"
                             :disabled="!editable || getCurrencyClauseApplicability(item, 'currencyClause').length !== 2">
                      <span class="a-checkbox__icon"></span>
                    </label>
                  </div>
                </td>

                <td class="table-tab__border-top">
                </td>
              </template>

              <td v-if="bid.permissions.CAN_EDIT_EXTRA_COST">
                <span class="a-container-form" v-if="item.editable">
                  <button class="a-accordion__ok-btn"
                          @click.prevent="onConfirmAddExtraCostItemToSpecification(item)">
                    <img src="@/assets/img/static/tab-ok.svg">
                  </button>
                  <button class="a-accordion__clear-btn"
                          @click.prevent="onCancelAddExtraCostItemToSpecification(item, i)">
                    <img src="@/assets/img/static/tab-close.svg">
                  </button>
                </span>

                <span class="a-container-form" v-else>
                  <button class="a-accordion__editing-btn"
                          :title="$t('buttons.modify')"
                          :disabled="!!editableItem"
                          @click.prevent="onEditExtraCostItemFromSpecification(item)">
                    <img src="@/assets/img/static/b-icon_edit.svg" alt="">
                  </button>

                  <button class="a-accordion__add-btn-label"
                          :title="$t('buttons.delete')"
                          :disabled="!!editableItem"
                          @click.prevent="onRemoveExtraCostItemFromSpecification(item)">
                    <img class="table-tab__img-3" src="@/assets/img/static/trashcan.svg" alt="">
                  </button>
                </span>
              </td>

              <td class="table-tab__border-top table-tab__width-180"></td>
            </tr>

            <tr>
              <th :class="{'table-tab__background-black': item.isExtra}">
              </th>

              <!-- Открытие таба table-tab__btn-open-->
              <th class="table-tab__th table-tab__th--row table-tab__btn-open">
              </th>

              <template>
                <td class="table-tab__border-bottom" colspan="5" >
                  <div v-if="canEditExtraCost  && item.editable">
                    <textarea class="a-textarea"
                              v-model="item.extraCostDescription"></textarea>
                  </div>
                  <span class="a-textarea a-textarea--disabled" v-else>{{item.extraCostDescription}}</span>
                </td>

                <td class="table-tab__border-bottom" colspan="4">
                </td>
              </template>

              <td class="table-tab__border-bottom" colspan="2"></td>
            </tr>

            <template v-for="(part, partId) in item.parts">
              <tr class="table-tab__open"
                  v-if="item.editable || item.parts[partId].count > 0">
                <th :class="{'table-tab__background-black': item.isExtra}"></th>
                <th class="table-tab__width-90 table-tab__th--row"></th>
                <td class="">
                  <label class="a-checkbox__label a-checkbox__label--disable">
                    <input class="a-checkbox__input"
                           type="checkbox"
                           disabled
                           :checked="item.parts[partId].count > 0">
                    <span class="a-checkbox__icon"><i></i></span>
                    <span class="a-checkbox__text">{{$t('form.lot.parts.part-number', {id: item.parts[partId].serial})}}</span>
                  </label>
                </td>

                <td>
                  <template v-if="item.editable">
                    <div :class="{ 'a-input-group--error': !item.parts[partId].disabled && $v.specs.$each[i].parts.$error }">
                      <input-percent class="a-input table-tab__input-max-width-85"
                                     :disabled="item.parts[partId].disabled"
                                     v-model="item.parts[partId].count">
                      </input-percent>
                    </div>
                  </template>
                  <template v-else>
                    {{item.parts[partId].count | percent}}
                  </template>
                </td>

                <td >%</td>
                <td colspan="9"></td>
              </tr>
            </template>
          </template>

          <!--  not extra item -->
          <template v-else>
            <tr>
              <!-- Открытие таба table-tab__btn-open-->
              <th class="table-tab__border-top"
                  :class="{'table-tab__background-red': item.isAdditional}">
              </th>

              <th class="table-tab__border-top table-tab__th table-tab__th--row text-nowrap">
                <!--              <img src="@/assets/img/static/arrow-up.png" alt="">-->
                <img class="table-tab__img-help"
                     src="@/assets/img/static/warning.svg"
                     v-if="wasSpecChangedByParticipant(item.position)">
                {{item.serial}}
              </th>

              <!--  nomenclature  -->
              <td class="table-tab__border-top">
                <template v-if="item.permissions.CAN_CHANGE_NOMEN_IN_SPEC_POSITION_IN_BID">
                  <div class="a-form-field" style="width: 180px">
                    <categories-search full-search v-model="item.catalog" @input="onCategoryChange($event, item)"></categories-search>
                  </div>
                </template>
                <template v-else-if="item.catalog && item.catalog.id">
                  {{item.catalog.name}}
                </template>
              </td>

              <td class="table-tab__border-top">
                <template v-if="!item.isAdditional">
                  <label v-if="!editable && item.dismiss">Не поставляется</label>
                  <label v-else-if="!editable && !item.dismiss">
                    {{item.percent ? $options.filters.percent(item.count) : item.count}}
                  </label>
                  <dropdown-new v-else
                                class="select-w-260"
                                :options="[
                                  { id: true, name: 'Не поставляется'},
                                  { id: false, name: item.percent ? $options.filters.percent(item.count) : item.count}
                                ]"
                                :value="item.dismiss"
                                @change="onDimissPositionClick(item, $event)">
                  </dropdown-new>
                </template>

                <template v-else-if="(item.isAdditional && item.parentPosition === 0)">
                  <label v-if="item.percent">{{item.count | percent}}%</label>
                  <div :class="{ 'a-input-group--error': $v.specs.$each[i].count.$error }"
                       v-else-if="editable">
                    <input-float :value="item.count"
                                 @change="onFieldChange(item, 'count', $event)">
                    </input-float>
                  </div>

                  <label v-else>{{item.count}}</label>
                </template>

                <template v-else>
                  <template v-if="item.percent">
                    {{item.parentCount | percent}}
                  </template>
                  <template v-else>
                    {{item.parentCount}}
                  </template>
                  *
                  <template v-if="editable && !isRetend">
                    <div class="a-form-field d-inline-block"
                         :class="{ 'a-input-group--error': $v.specs.$each[i].multiplier.$anyError }">
                      <input-float class="a-input table-tab__input-max-width-85"
                                   v-model="item.multiplier"
                                   @change="saveForm()"></input-float>
                    </div>
                  </template>
                  <template v-else>
                    {{item.multiplier}}
                  </template>
                  =
                  <template v-if="item.percent">
                    {{item.count | percent}}
                  </template>
                  <template v-else>
                    {{item.count}}
                  </template>
                </template>
              </td>

              <td class="table-tab__border-top" colspan="7" v-if="item.dismiss">
              </td>

              <template v-if="!item.dismiss">
                <td class="table-tab__border-top" v-if="!item.dismiss">
                  <template v-if="item.isAdditional">
                    <span v-if="item.percent">
                      % процент
                    </span>
                    <span v-else-if="item.okeiName">
                      {{item.okeiName}}
                    </span>
                    <span v-else>
                      {{editable ? 'укажите в поле ниже' : 'из справочника'}}
                    </span>
                    <!--                  <dropdown-new class="select-w-140"-->
                    <!--                                :options="[-->
                    <!--                                  { id: false, name: 'из справочника' },-->
                    <!--                                  { id: true, name: '% процент'}-->
                    <!--                                ]"-->
                    <!--                                v-model="item.percent"-->
                    <!--                                v-else-->
                    <!--                                @change="onPercentChange(item)">-->
                    <!--                  </dropdown-new>-->
                  </template>
                  <template v-else>
                    {{item.percent ? '% процент' : item.okeiName}}
                  </template>
                </td>

                <td class="table-tab__border-top" v-if="editable">
                  <div class="a-form-field"
                       :class="{ 'a-form-field--error': $v.specs.$each[i].price.$anyError }">
                    <input-cost class="a-input table-tab__input-max-width-140 table-tab__width-140"
                                v-model="item.price"
                                @change="saveForm()"></input-cost>

                    <span class="a-helper-text"
                          :class="{'a-validation-error': $v.specs.$each[i].price.$dirty && !$v.specs.$each[i].price.isDecreasedInRetend}"
                          v-if="item.original">Не более {{item.original.price | price}} {{$t(item.original.currency.label)}}</span>
                    <span class="a-helper-text"
                          :class="{'a-validation-error': $v.specs.$each[i].price.$dirty && !$v.specs.$each[i].price.isNotTooHigh}"
                          v-else-if="item.maxPrice">Не более {{item.maxPrice | price}} {{$t(lot.currency.label)}}</span>
                  </div>
                </td>
                <td class="table-tab__border-top text-nowrap" v-else>{{item.price | price}}</td>

                <td class="table-tab__border-top text-nowrap">
                  {{(item.price * (item.percent ? 1 :item.count)) | price}}
                </td>

                <td class="table-tab__border-top">
                  <div class="a-form-field"
                       :class="{ 'a-form-field--error': $v.specs.$each[i].currency.$anyError }" v-if="editable && (!isRetend || item.isEmptyCurrency)">
                    <dropdown-new :options="getBidCurrencies(item, 'currency')"
                                  :value="item.currency"
                                  @change="onDependentFieldChange(item, 'currency', $event)"
                                  ></dropdown-new>
                  </div>
                  <p v-else>{{$t(item.currency.label)}}</p>
                </td>

                <td class="table-tab__border-top">
                  <div class="a-form-field"
                       :class="{ 'a-form-field--error': $v.specs.$each[i].currencyContract.$anyError }" v-if="editable && (!isRetend || item.isEmptyCurrency)">
                    <dropdown-new :options="getPaymentCurrencies(item, 'currencyContract')"
                                  :disabled="getPaymentCurrencies(item).length === 0"
                                  :value="item.currencyContract"
                                  @change="onDependentFieldChange(item, 'currencyContract', $event)"></dropdown-new>
                  </div>
                  <p v-else>{{$t(item.currencyContract.label)}}</p>
                </td>

                <td class="table-tab__border-top">
                  <div class="a-checkbox">
                    <label class="a-checkbox__label" :class="{'a-checkbox__label--disable': !editable || (isRetend && !item.isEmptyCurrency) || getCurrencyClauseApplicability(item).length !== 2}" >
                      <input class="a-checkbox__input"
                             type="checkbox"
                             :checked="item.currencyClause"
                             @change="onDependentFieldChange(item, 'currencyClause', $event.target.checked)"
                             :disabled="!editable || (isRetend && !item.isEmptyCurrency) || getCurrencyClauseApplicability(item, 'currencyClause').length !== 2">
                      <span class="a-checkbox__icon"></span>
                    </label>
                  </div>
                </td>

                <td class="table-tab__border-top">
                  <div class="a-checkbox admin-buy__input-and-checkbox">
                    <div class="a-checkbox" v-if="editable">
                      <label class="a-checkbox__label">
                        <input class="a-checkbox__input"
                               type="checkbox"
                               :checked="item.syndicate && item.syndicate.length !== 0"
                               @click.prevent="item.syndicate = ''">
                        <span class="a-checkbox__icon"></span>
                        <span class="a-checkbox__text"></span>
                      </label>
                    </div>
                    <input type="text"
                           class="a-input a-input--w-280"
                           :disabled="!editable || isRetend"
                           v-model="item.syndicate"
                           @change="saveForm()">
                  </div>
                </td>
              </template>

              <td v-if="bid.permissions.CAN_EDIT_EXTRA_COST">
                <button class="a-accordion__add-btn-label"
                        @click.prevent="onAddExtraCostItemToSpecification(item)">
                  <img src="@/assets/img/static/b-icon_plus-str.svg" alt="">
                </button>
              </td>
              <td v-else>
                <button class="a-accordion__add-btn-label"
                        v-if="!item.parentPosition && editable && !isRetend && canAddNomenclature"
                        @click.prevent="onAddChildItemToSpecification(item)">
                  <img src="@/assets/img/static/b-icon_plus-str.svg" alt="">
                  Добавить
                </button>

                <button class="a-accordion__add-btn-label"
                        :title="$t('buttons.delete')"
                        v-if="item.isAdditional && editable && !isRetend"
                        @click.prevent="onRemoveItemFromSpecification(item)">
                  <img class="table-tab__img-3" src="@/assets/img/static/trashcan.svg" alt="">
                </button>
              </td>
              <td class="table-tab__border-top table-tab__width-180"></td>
            </tr>

            <tr :class="{'declined-additional-spec-item': item.state && item.state.valueOf() === enums.AdditionalSpecItemState.DECLINED}">
              <th :class="{'table-tab__background-red': item.isAdditional}">
              </th>

              <!-- Открытие таба table-tab__btn-open-->
              <th class="table-tab__th table-tab__th--row table-tab__btn-open">
              </th>

              <td colspan="9" v-if="item.dismiss"></td>
              <template v-else>
                <td class="table-tab__border-bottom" colspan="5" >
                  <div class="a-flex-start-nowrap"
                       :class="{ 'a-input-group--error': $v.specs.$each[i].additionalNomenclature.$error }"
                       v-if="editable && !isRetend">
                  <textarea class="a-textarea"
                            v-model="item.additionalNomenclature"
                            rows="7"
                            :placeholder="$t('form.lot.specs.additional-nomenclature-helper')"
                            @change="saveForm()"></textarea>

                    <v-popover class="d-inline-block align-top" placement="right" v-if="item.additionalNomenclature">
                      <img src="@/assets/img/static/info.svg">

                      <template slot="popover">
                        <div style="white-space: pre-line; text-align: left">{{$t('form.lot.specs.additional-nomenclature-helper')}}</div>
                      </template>
                    </v-popover>
                  </div>
                  <textarea class="a-textarea"
                            disabled
                            :value="item.additionalNomenclature"
                            v-else-if="item.additionalNomenclature">
                  </textarea>
                </td>

                <td class="table-tab__border-bottom" colspan="5">
                  <label class="a-color-red" v-if="!getAllowAdvancePayment(item)">При данной комбинации валют аванс не предусмотрен</label>

                  <template v-if="getSelectedFixDateChoice(item)">
                    <div class="a-container-form">
                      <label class="u-margin-right-7">Дата фиксации цены в валюте фиксации цены:</label>
                      <div class="a-form-field select-w-380"
                           :class="{ 'a-form-field--error': $v.specs.$each[i].fixDate.$anyError }"
                           v-if="showFixDateChoice(item) && editable && !isRetend">
                        <dropdown-new class="select-w-380"
                                      :options="getFixDateChoices(item)"
                                      :value="item.fixDate"
                                      @change="onDependentFieldChange(item, 'fixDate', $event)">
                        </dropdown-new>
                      </div>
                      <label v-else>{{$t(getSelectedFixDateChoice(item).label)}}</label>
                    </div>

                    <div class="a-container-form">
                      Вариант: {{getChosenRule(item) | get('type')}}
                    </div>

                    <div class="a-container-form u-text-underline">
                      {{getChosenRule(item) | get('bidRuleUserComment')}}
                    </div>
                  </template>
                </td>
              </template>

              <td class="table-tab__border-bottom" colspan="1"></td>
            </tr>

            <tr v-if="item.state">
              <th :class="{'table-tab__background-red': item.isAdditional}">
              </th>

              <!-- Открытие таба table-tab__btn-open-->
              <th class="table-tab__th table-tab__th--row table-tab__btn-open">
              </th>

              <td colspan="9">
                <template v-if="item.permissions.CAN_APPROVE_SPEC_POSITION_IN_BID || item.permissions.CAN_DECLINE_SPEC_POSITION_IN_BID">
                  <div class="a-input-group">
                    <dropdown-new class="select-w-260"
                                  :options="[
                                  {
                                    id: enums.AdditionalSpecItemState.NONE,
                                    name: enums.AdditionalSpecItemState.label('NONE')
                                  },
                                  {
                                    id: enums.AdditionalSpecItemState.APPROVED,
                                    name: enums.AdditionalSpecItemState.label('APPROVED'),
                                    disabled: !item.permissions.CAN_APPROVE_SPEC_POSITION_IN_BID
                                  },
                                  {
                                    id: enums.AdditionalSpecItemState.DECLINED,
                                    name: enums.AdditionalSpecItemState.label('DECLINED'),
                                    disabled: !item.permissions.CAN_DECLINE_SPEC_POSITION_IN_BID
                                  },
                              ]"
                                  v-model="item.state"></dropdown-new>
                    <button class="gui-btn gui-btn--red u-margin-left-20"
                            @click.prevent="onApproveAdditionalSpecItemClick(item)">Сохранить</button>
                  </div>
                  <textarea class="a-textarea u-margin-top-13"
                            placeholder="Причина"
                            v-model="item.reason"
                            v-if="item.state.valueOf() === enums.AdditionalSpecItemState.DECLINED">
                </textarea>
                </template>
                <template v-else-if="item.state.valueOf() === enums.AdditionalSpecItemState.NONE">
                  <label><b>Статус:</b> Будет рассмотрена организатором</label>
                </template>
                <template v-else>
                  <label><b>Статус:</b> {{$t(item.state.label)}}</label>
                  <p><b>Причина:</b> {{item.reason}}</p>
                </template>

              </td>

              <td class="table-tab__border-bottom" colspan="2"></td>
            </tr>

            <template v-for="(part, partId) in item.parts">
              <tr class="table-tab__open" v-if="!item.dismiss && item.parts[partId].count > 0">
                <th :class="{'table-tab__background-red': item.isAdditional}"></th>
                <th class="table-tab__width-90 table-tab__th--row"></th>
                <td class="">
                  <label class="a-checkbox__label " :class="{'a-checkbox__label--disable': !editable || item.parts[partId].count === 0}">
                    <input class="a-checkbox__input"
                           type="checkbox"
                           :disabled="!editable || item.parts[partId].count === 0"
                           :checked="item.parts[partId].count > 0">
                    <span class="a-checkbox__icon"><i></i></span>
                    <span class="a-checkbox__text">{{$t('form.lot.parts.part-number', {id: item.parts[partId].serial})}}</span>
                  </label>
                </td>

                <td v-if="item.percent">{{item.parts[partId].count | percent}}</td>
                <td v-else>{{item.parts[partId].count}}</td>

                <td >{{item.percent ? '%' : item.okeiName}}</td>
                <td colspan="9"></td>
              </tr>
            </template>
          </template>
        </template>
        </tbody>
      </table>
    </div>
    </section>

    <div class="a-container-form u-padding-top-24px" v-if="editable && !isRetend && canAddNomenclature">
      <button class="gui-btn gui-btn--red" @click.prevent="onAddItemToSpecification">Добавить номенклатуру в спецификацию</button>
    </div>

    <loading v-if="loading"></loading>
  </div>
</template>

<script>
  import Errors from '@/api/types/errors'
  import { numeric, requiredIf } from '@/validators'
  import CommonMixins from '../mixins/common'
  import CategoriesSearch from '@/components/common/inputs/CategoriesSearch'
  import SpecificationItemsFilter from "./SpecificationItemsFilter";

  export default {
    components: {
      SpecificationItemsFilter,
      CategoriesSearch
    },

    props: {
      lot: Object,
      bid: Object
    },

    mixins: [
      CommonMixins
    ],

    data: () => ({
      editableItem: undefined,
      filteredSpecs: [],
    }),

    computed: {
      specs() {
        return this.filteredSpecs; //this.bid.specs;
      },

      editable() {
        return !!this.lot.request.permissions.HAS_ACCREDITATION && (this.bid.permissions.CAN_EDIT_BID || this.bid.isEditingForRetend)
      },

      canAddNomenclature() {
        return this.lot.request.permissions.CAN_EDIT_REQUEST;
      },

      isRetend() {
        return this.bid.isEditingForRetend;
      },

      canEditExtraCost() {
        return this.bid.permissions.CAN_EDIT_EXTRA_COST;
      },

      bidRules: {
        get() {
          return this.lot.request.bidRules;
        }
      },

      additionalBidRules: {
        get() {
          return this.lot.request.additionalBidRules;
        }
      }
    },

    validations: {
      specs: {
        $each: {
          multiplier: {
            valid(value, spec) {
              let valid = true;

              if (spec.isAdditional && spec.parentPosition !== 0) {
                valid = !!value;
              }

              return valid;
            }
          },

          count: {
            validCount(value, spec) {
              if (!numeric(value)) {
                return false;
              }

              return value > 0;
            }
          },

          price: {
            isNotTooHigh(value, spec) {
              if (!numeric(value)) {
                return false;
              }

              if (spec.isTooHigh) {
                return false;
              }

              return true;
            },

            isDecreasedInRetend(value, spec) {
              if (!numeric(value)) {
                return false;
              }

              if (spec.original) {
                return value <= spec.original.price;
              }

              return true;
            },

            validPrice(value) {
              if (!numeric(value)) {
                return false;
              }

              return value > 0;
            }
          },

          currency: {
            isFilled(value) {
              if (value instanceof this.enums.Currency) {
                return value.valid && !value.EMPTY;
              }

              return !!value;
            },
            normalPrice(value, spec) {
              return spec.isTooHigh ? false: true;
            }
          },

          currencyContract: {
            isFilled(value) {
              if (value instanceof this.enums.Currency) {
                return value.valid && !value.EMPTY;
              }

              return !!value;
            }
          },

          fixDate: {
            isFilled(value, spec) {
              if (!this.showFixDateChoice(spec)) return true;

              if (value instanceof this.enums.FixDateChoice) {
                return value.valid && !value.EMPTY;
              }

              return !!value;
            }
          },

          additionalNomenclature: {
            required: requiredIf(function(spec) {
              return spec.isAdditional;
            })
          },

          parts: {
            validParts(parts, spec) {
              if (!spec.isExtra) return true;

              const total = parts.reduce((acc, p) => acc + p.count, 0);
              return total === 10000;
            }
          }
        }
      }
    },

    watch: {
      'bid.specs': {
        immediate: true,
        //deep: true,
        handler() {
          // if (this.bid.specs.length != this.filteredSpecs.length) {
          //   debugger
          //   this.filteredSpecs = [];
          // }

          this.$v.$touch();
        }
      },

      specs: {
        immediate: true,
        deep: true,
        handler() {
          this.$v.$touch();
        }
      }
    },

    methods: {
      wasSpecChangedByParticipant(position) {
        return !!_.find(this.lot.request.userChangesHistory, { bidNum: this.bid.num, position });
      },

      getBidRules(item, filters) {
        return _.filter(this.bidRules, filters);
      },

      getAdditionalBidRules(item, filters) {
        return _.reduce(this.additionalBidRules, (acc, r) => {
          const rules = _.filter(r.rules, filters);

          if (rules.length) {
            acc.push({
              nomen: r.nomen,
              nomenText: r.name,
              rules: rules
            })
          }

          return acc;
        }, []);
      },

      getAdditionalCostName(id) {
        const item = _.find(this.additionalBidRules, {nomen: id});
        return _.get(item, 'name');
      },

      getExtraCosts(item) {
        const parentItem = _.find(this.bid.specs, { position: item.parentPosition });

        const values = this.getAdditionalBidRules(parentItem, {
          'bidByn': parentItem.currency.valueOf() === this.enums.Currency.BYN,
          'payByn': parentItem.currencyContract.valueOf() === this.enums.Currency.BYN,
          'currencyClause': !!parentItem.currencyClause
        });

        return values.map(v => ({
          id: v.nomen,
          name: v.nomenText
        }))
      },

      onExtraCostChange(item) {
        item.percent = _.find(this.additionalBidRules, { nomen: item.extraCost }).percent;
        if (!item.percent) {
          item.count = 1;
        }
      },

      getExtraCostBidCurrencies(item, field) {
        return this.getBidCurrencies(item, field);
        //return this.enums.Currency.options.all;
      },

      getExtraCostPaymentCurrencies(item, field) {
        const currencies = this.getPaymentCurrencies(item);

        let options = currencies;

        if (item.percent) {
          const parentItem = _.find(this.bid.specs, { position: item.parentPosition });
          // current or BYN
          options = [];

          if (_.find(currencies, { id: this.enums.Currency.BYN })) {
            options.push({id: this.enums.Currency.BYN, name: this.enums.Currency.label('BYN')});
          }

          if (!_.find(options, { id: parentItem.currencyContract.valueOf() })) {
            if (_.find(currencies, { id: parentItem.currencyContract.valueOf() })) {
              options.push({
                id: parentItem.currencyContract.valueOf(),
                name: this.enums.Currency.label(parentItem.currencyContract.valueOf())
              })
            }
          }
        }

        if (options.length === 1 && field) {
          item[field] = options[0].id;
        }

        return options;
      },

      getBidCurrencies(item, field) {
        const values = this.getBidRules(item).reduce((acc, rule) => {
          acc[rule.bidByn] = rule.bidByn;
          return acc;
        }, {});

        let options = [];

        if (values[true] === true) {
          options.push.apply(options, this.enums.Currency.options.BYN);
        }

        if (values[false] === false) {
          options.push.apply(options, this.enums.Currency.options.NOT_BYN);
        }

        let lotSpec = _.find(this.lot.specs, { position: item.position });
        if (!lotSpec && item.parentPosition) {
          lotSpec = _.find(this.lot.specs, { position: item.parentPosition });
        }

        if (lotSpec && lotSpec.bidCurrency.length) {
          options = _.filter(options, o => {
            return _.find(lotSpec.bidCurrency, c => {
              return c.valueOf() === o.id.valueOf()
            })
          })
        }

        if (options.length === 1 && field) {
          item[field] = options[0].id;
        }

        return options;
      },

      async onFieldChange(item, field, value) {
        item[field] = value;

        if (!item.isExtra) {
          await this.saveForm();
        }
      },

      async onDependentFieldChange(item, field, value) {
        item[field] = value;

        if (field !== 'currency') {
          const options = this.getBidCurrencies(item);

          if (!_.some(options, o => o.id === item.currency.valueOf())) {
            item.currency = this.enums.Currency.EMPTY;
          }
        }

        if (field !== 'currencyContract') {
          const options = this.getPaymentCurrencies(item);

          if (!_.some(options, o => o.id === item.currencyContract.valueOf())) {
            item.currencyContract  = this.enums.Currency.EMPTY;
          }
        }

        if (field !== 'currencyClause') {
          const options = this.getCurrencyClauseApplicability(item);

          if (!_.includes(options, item.currencyClause)) {
            item.currencyClause = !!_.head(options);
          }
        }

        if (field !== 'fixDate') {
          const options = this.getBidRules(item);

          if (!_.includes(options, item.fixDate)) {
            item.fixDate = !!_.head(options);
          }
        }

        if (!item.isExtra) {
          await this.saveForm();
        }
      },

      getPaymentCurrencies(item, field) {
        const values = this.getBidRules(item, {
          'bidByn': item.currency.valueOf() === this.enums.Currency.BYN
        }).reduce((acc, rule) => {
          acc[rule.payByn] = rule.payByn;
          return acc;
        }, {});

        let options = [];

        if (values[true] === true) {
          options.push.apply(options, this.enums.Currency.options.BYN);
        }

        if (values[false] === false && item.currency.valid && item.currency.valueOf() !== this.enums.Currency.BYN) {
          Array.prototype.push.apply(options, [{ id: item.currency.valueOf(), name: item.currency.label }]);
        }
        else if (values[false] === false && item.currency.valueOf() === this.enums.Currency.BYN) {
          Array.prototype.push.apply(options, this.enums.Currency.options.NOT_BYN);
        }

        let lotSpec = _.find(this.lot.specs, { position: item.position });
        if (!lotSpec && item.parentPosition) {
          lotSpec = _.find(this.lot.specs, { position: item.parentPosition });
        }

        if (lotSpec && lotSpec.currencyContract.length) {
          options = _.filter(options, o => {
            return _.find(lotSpec.currencyContract, c => {
              return c.valueOf() === o.id.valueOf()
            })
          })
        }

        if (options.length === 1 && field) {
          item[field] = options[0].id;
        }

        return options;
      },

      getCurrencyClauseApplicability(item, field) {
        const values = this.getBidRules(item, {
          'bidByn': item.currency.valueOf() === this.enums.Currency.BYN,
          'payByn': item.currencyContract.valueOf() === this.enums.Currency.BYN
        }).reduce((acc, rule) => {
          acc[rule.currencyClause] = rule.currencyClause;
          return acc;
        }, {});

        const options = [];

        let lotSpec = _.find(this.lot.specs, { position: item.position });
        if (!lotSpec && item.parentPosition) {
          lotSpec = _.find(this.lot.specs, { position: item.parentPosition });
        }

        if (values[true] === true && (!lotSpec || !lotSpec.currencyClause.NOT_APPLICABLE)) {
          options.push(true);
        }

        if (values[false] === false && (!lotSpec || !lotSpec.currencyClause.APPLICABLE)) {
          options.push(false);
        }

        if (options.length === 1 && field) {
          item[field] = options[0];
        }

        return options;
      },

      getChosenRules(item) {
        const filters = {
          'bidByn': item.currency.valueOf() !== this.enums.Currency.EMPTY ? item.currency.valueOf() === this.enums.Currency.BYN : undefined,
          'payByn': item.currencyContract.valueOf() !== this.enums.Currency.EMPTY ? item.currencyContract.valueOf() === this.enums.Currency.BYN : undefined,
          'currencyClause': !!item.currencyClause
        };

        if (_.get(item.fixDate, 'valid') && item.fixDate.valueOf() !== this.enums.FixDateChoice.EMPTY) {
          filters.fixDate = item.fixDate.valueOf();
        }

        return this.getBidRules(item, filters);
      },

      getChosenRule(item) {
        const values = this.getChosenRules(item);
        return _.head(values);
      },

      getAllowAdvancePayment(item) {
        const values = this.getChosenRules(item).reduce((acc, rule) => {
          acc[rule.allowAdvance] = rule.allowAdvance;
          return acc;
        }, {});

        item.isAdvancePaymentAllowed = (values[true] === true && values[false] !== false);

        if (item.parts) {
          item.parts.forEach(specPart => {
            if (!specPart.count) return;

            const bidPart = _.find(this.bid.parts, p => {
              if (p.position) {
                return item.position === p.position && p.part === specPart.part;
              }
              return p.part === specPart.part;
            });

            if (bidPart && bidPart.payments) {
              bidPart.payments.forEach(e => {
                if (e.type === 'contract' && !item.isAdvancePaymentAllowed) {
                  e.isBlocked = true;
                  e.blockedReason = new this.enums.AdvancePaymentBlockReason(this.enums.AdvancePaymentBlockReason.COMBINATION);
                  e.percent = 0;
                  e.duration = 0;
                }
                else if (e.type === 'contract' && item.isAdvancePaymentAllowed) {
                  e.isBlocked = false;
                  e.blockedReason = undefined;
                }
              })
            }
          });
        }

        return item.isAdvancePaymentAllowed;
      },

      getFixDateChoices(item) {
        const filters = {
          'bidByn': item.currency.valueOf() !== this.enums.Currency.EMPTY ? item.currency.valueOf() === this.enums.Currency.BYN : undefined,
          'payByn': item.currencyContract.valueOf() !== this.enums.Currency.EMPTY ? item.currencyContract.valueOf() === this.enums.Currency.BYN : undefined,
          'currencyClause': !!item.currencyClause
        };

        const values = this.getBidRules(item, filters).reduce((acc, rule) => {
          acc[rule.fixDate] = rule.fixDate;
          return acc;
        }, {});

        const results = this.enums.FixDateChoice.options.all.filter(e => values[e.id]);

        return results.length > 1 ? results : undefined;
      },

      showFixDateChoice(item) {
        return this.getFixDateChoices(item) || (item.fixDate.valid && item.fixDate.valueOf() !== this.enums.FixDateChoice.EMPTY);
      },

      getSelectedFixDateChoice(item) {
        if (this.showFixDateChoice(item)) {
          return item.fixDate;
        }
        else {
          const filters = {
            'bidByn': item.currency.valueOf() !== this.enums.Currency.EMPTY ? item.currency.valueOf() === this.enums.Currency.BYN : undefined,
            'payByn': item.currencyContract.valueOf() !== this.enums.Currency.EMPTY ? item.currencyContract.valueOf() === this.enums.Currency.BYN : undefined,
            'currencyClause': !!item.currencyClause
          };

          const values = this.getBidRules(item, filters).reduce((acc, rule) => {
            acc[rule.fixDate] = rule.fixDate;
            return acc;
          }, {});

          const value = _.head(_.keys(values));
          return value ? new this.enums.FixDateChoice(value) : undefined;
        }
      },

      async onDownloadSpecClick() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('exportBidSpecification', {
              requestId: this.lot.request.id,
              bidId: this.bid.id,
              filename: `${this.lot.catalog.name}-${this.lot.request.id}-${this.bid.num}-specification`
            });
          }
          catch(e) {
            console.error('failed download of bid specification', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onApproveAdditionalSpecItemClick(item) {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('approveAdditionalSpecItem', {
              requestId: this.lot.request.id,
              bidId: this.bid.id,
              position: item.position,
              approved: item.state.valueOf() === this.enums.AdditionalSpecItemState.APPROVED,
              reason: item.reason
            });
          }
          catch(e) {
            console.error('failed download of bid specification', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onFileSelected(file) {
        try {
          const lot = await this.$store.dispatch('uploadBidSpecification', {
            lotId: this.lot.id,
            requestId: this.lot.request.id,
            bidId: this.bid.id,
            file
          });

          const positionsToDismiss = lot.request.bids.reduce((acc, bid) => {
            _.filter(bid.specs, { dismiss: true }).map(item => {
              acc.push({
                bidId: bid.id,
                position: item.position
              });
            });

            return acc;
          }, []);

          await this.saveForm();

          if (!this.isRetend) {
            positionsToDismiss.map(async item => {
              try {
                await this.$store.dispatch('dismissItemInSpecification', {
                  lotId: lot.id,
                  requestId: lot.request.id,
                  bidId: item.bidId,
                  position: item.position,
                  dismiss: false
                });
              }
              catch(e) {
                console.error('failed change dismiss flag of item of bid specification', e);
                this.globalErrorHandler(e);
              }
            });
          }
        }
        catch(e) {
          console.error('failed upload of bid specification', e);
          this.globalErrorHandler(e);
        }
      },

      async onAddItemToSpecification( ) {
        return this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('addItemToSpecification', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              bidId: this.bid.id,
              position: 0
            });
          }
          catch(e) {
            console.error('failed upload of bid specification', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onAddChildItemToSpecification(item) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('addItemToSpecification', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              bidId: this.bid.id,
              position: item.position
            });
          }
          catch(e) {
            console.error('failed upload of bid specification', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onAddExtraCostItemToSpecification(item) {
        if (this.lot.retends.length === 0) {
          this.showError({
            title: 'Добавление доп. расходов',
            error: 'Перед добавлением в предложение доп. расходов откройте форму формирования переторжки'
          });

          return;
        }

        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('addExtraCostItemToSpecification', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              bidId: this.bid.id,
              position: item.position
            });
            this.editableItem = {};
          }
          catch(e) {
            console.error('failed upload of bid specification', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onConfirmAddExtraCostItemToSpecification(item) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('confirmAddingExtraCostItemToSpecification', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              bidId: this.bid.id,
              bidNum: this.bid.num,
              position: item.position,
              item
            });
            this.editableItem = undefined;
          }
          catch(e) {
            console.error('failed upload of bid specification', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onCancelAddExtraCostItemToSpecification(item, i) {
        if (_.isEmpty(this.editableItem)) {
          this.specs.splice(i, 1);
        }
        else {
          this.$set(this.specs, i, this.editableItem);
        }

        this.editableItem = undefined;
      },

      async onEditExtraCostItemFromSpecification(item) {
        if (this.editableItem) return;

        this.editableItem = _.cloneDeep(item);
        item.editable = true;
      },

      async onRemoveExtraCostItemFromSpecification(item) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('removeExtraCostItemFromSpecification', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              bidNum: this.bid.num,
              position: item.position,
              extraCost: item.extraCost
            });
          }
          catch(e) {
            console.error('failed u pload of bid specification', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onRemoveItemFromSpecification(item) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('removeItemFromSpecification', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              bidId: this.bid.id,
              position: item.position
            });
          }
          catch(e) {
            console.error('failed u pload of bid specification', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onDimissPositionClick(item, value) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('dismissItemInSpecification', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              bidId: this.bid.id,
              position: item.position,
              dismiss: !value
            });
          }
          catch(e) {
            console.error('failed change dismiss flag of item of bid specification', e);
            this.globalErrorHandler(e);
          }
        });
      },

      onPercentChange(item) {
        item.count = item.percent ? 10000 : 0;
      },

      onCategoryChange(event, item) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('setNomenclatureInAdditionalSpecItem', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              bidId: this.bid.id,
              position: item.position,
              okeId: event.id
            });
          }
          catch(e) {
            console.error('failed changing nomenclature of additional item of bid specification', e);
            this.globalErrorHandler(e);
          }
        });
      }
    }
  }
</script>

<style scoped>
  .table-tab__background-black {
    background: rgba(0, 0, 0, 0.1);
  }
</style>
